module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data && _vm.data._isScene) ? _c('div', {
    staticClass: "dynamic-product-simple scene-wrap"
  }, [_c('div', {
    staticClass: "scene-img",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "click": _vm.jump
    }
  }, [(_vm.data.sceneVideo) ? _c('video', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "object-fit": "cover"
    },
    attrs: {
      "webkit-playsinline": "true",
      "playsinline": "true",
      "poster": _vm.data.sceneCover,
      "src": _vm.data.sceneVideo,
      "autoplay": true,
      "controls": false
    },
    domProps: {
      "muted": true
    }
  }) : _c('img', {
    attrs: {
      "lazy": true,
      "src": _vm.data.sceneImage || _vm.data.sceneCover
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line-btm"
  }), _vm._v(" "), (_vm.index % 2 != 1) ? _c('div', {
    staticClass: "line-rt"
  }) : _vm._e()]) : _c('div', {
    staticClass: "dynamic-product-simple"
  }, [(_vm.productImage) ? _c('div', {
    staticClass: "product-image",
    on: {
      "click": _vm.jump
    }
  }, [_c('beast-image', {
    attrs: {
      "lazy": true,
      "defaultImage": _vm.defaultImage,
      "src": _vm.productImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-state"
  }, [(_vm.data.foretell) ? _c('div', {
    staticClass: "corner-boxs"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.data.offShelf) ? _c('div', {
    staticClass: "corner-boxs"
  }, [_vm._m(1)]) : (_vm.data.soldOut) ? _c('div', {
    staticClass: "corner-boxs"
  }, [_vm._m(2)]) : _vm._e()])], 1) : _c('div', {
    staticClass: "product-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.defaultImage
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product-infos",
    on: {
      "click": _vm.jump
    }
  }, [_c('div', {
    staticClass: "summary",
    class: {
      'normal': _vm.data.copywriter && _vm.data.copywriter.type !== 'NORMAL',
        'hidden': !_vm.data.copywriter
    },
    style: ({
      'display': _vm.data._showSummary ? 'none' : 'block'
    })
  }, [_vm._v(_vm._s(_vm.data.copywriter && _vm.data.copywriter.textContent || '1'))]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.data.name))]), _vm._v(" "), (_vm.data.mainStationFirst) ? _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("首单价")]), _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('div', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : (!_vm.data.newcomerTag) ? _c('div', {
    staticClass: "prices",
    class: {
      'rush-color': _vm.data.rush
    }
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('div', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]) : _c('div', {
    staticClass: "prices newn"
  }, [_c('div', {
    staticClass: "price discount-price"
  }, [_c('span', {
    staticClass: "newn-tag"
  }, [_vm._v("新人价")]), _c('price', {
    attrs: {
      "data": _vm.data.price
    }
  })], 1), _vm._v(" "), (_vm.data.price < _vm.data.rawPrice) ? _c('div', {
    staticClass: "price raw-price"
  }, [_c('price', {
    attrs: {
      "data": _vm.data.rawPrice
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.data.refunds) ? _c('div', {
    staticClass: "refund-box"
  }, [_c('div', {
    staticClass: "refund"
  }, [_vm._v("约返" + _vm._s(_vm._f("formatPrice")(_vm.data.refunds)) + "元")])]) : _vm._e()]), _vm._v(" "), (_vm.data.deliveryTag === '01' || _vm.data.deliveryTag === '03') ? _c('div', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "m"
  }, [_vm._v("该区域不支持")])]) : _vm._e(), _vm._v(" "), (_vm.data.deliveryTag === '02') ? _c('div', {
    staticClass: "support"
  }, [_c('div', {
    staticClass: "m"
  }, [_vm._v("该时间不支持")]), _vm._v(" "), _c('div', {
    staticClass: "m-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "t",
    on: {
      "click": function($event) {
        return _vm.getDate(_vm.data)
      }
    }
  }, [_vm._v("查看可选时间")])]) : _vm._e(), _vm._v(" "), (_vm.data.customizable) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("可定制")]) : (_vm.data.isOversea) ? _c('div', {
    staticClass: "tag"
  }, [_vm._v("跨境商品")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "line-btm"
  }), _vm._v(" "), (_vm.index % 2 != 1) ? _c('div', {
    staticClass: "line-rt"
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag",
    staticStyle: {
      "border": "solid 0.8px #ABACAD",
      "color": "#ABACAD",
      "line-height": "1.8"
    }
  }, [_c('span', [_vm._v("即将开售")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag",
    staticStyle: {
      "border": "solid 0.8px #ABACAD",
      "color": "#ABACAD",
      "line-height": "1.8"
    }
  }, [_c('span', [_vm._v("下架")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-tag",
    staticStyle: {
      "border": "solid 0.8px #ABACAD",
      "color": "#ABACAD",
      "line-height": "1.8"
    }
  }, [_c('span', [_vm._v("售罄")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e956e3c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/simple-product-new/index.vue
// module id = 185
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 13 14 16 17 19 21 26 28 29 30 31 36 37 40 42